var _polygon, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHoldThis = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "13.79291 8.94312 10.74908 4.51617 10.75 4.5 10.73706 4.49915 10 3.42615 9.26105 4.49915 9.25 4.5 9.24908 4.51617 6.20709 8.94312 7.44312 9.79291 9.24908 7.16412 9.25 14 10.75 14 10.74908 7.16412 12.55688 9.79291 13.79291 8.94312",
  fillRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 1.5,
  r: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.75,
  cy: 1.5,
  r: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5
})));
export default SvgHoldThis;